export const URL = "https://www.chithracineplex.com/webapi/";
export const UPLOADS="https://www.chithracineplex.com/uploads/";
/*export const URL = "https://www.josecinemas.com/webapi/";
export const UPLOADS="https://www.josecinemas.com/uploads/";*/
export const EBKEY = "XPWEHHO1H6";
